module.exports = __webpack_public_path__ + "static/img/zanwu.8e6b4f5e.png";